// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { priceStyles } from "@eisinc/Overrides/Widgets/ProductDetails/ProductDetailsPrice";
import { fontConfig } from "@eisinc/XDL/PreStyle/typography";
import { TypographyProps } from "@insite/mobius/Typography";
import { css } from "styled-components";

const priceTextProps: TypographyProps = {
    variant: "h2",
    as: "span",
    css: css`
        display: flex;
        margin-bottom: 0;
    `,
};

priceStyles.wrapper = {
    css: css``,
};

priceStyles.productPrice = {
    wrapper: {
        css: css`
            display: flex;
            flex-direction: column;
            align-items: flex-start;
        `,
    },
    priceWrapper: {
        css: css`
            display: flex;
            align-items: baseline;
        `,
    },
    packWrapper: {
        // hide pack from the price because it is displayed in another place.
        css: css`
            display: none;
        `,
    },
    price: {
        priceText: { ...priceTextProps },
        unitOfMeasureText: {
            size: fontConfig.singleLineRegular.size,
            lineHeight: fontConfig.singleLineRegular.lineHeight,
            weight: fontConfig.weight.regular,
        },
        realTimeText: { ...priceTextProps },
    },
    quoteMessage: {
        text: { ...priceTextProps },
    },
};

priceStyles.variantParentProductPrice = {
    priceText: {
        variant: "h2",
        forwardAs: "span",
        css: css`
            display: flex;
            margin-bottom: 0;
        `,
    },
};
